import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { AllCampsiteRegionsQuery } from '@custom/schema';

export const useAllCampsiteRegions = () => {
  return useStaticQuery(graphql(AllCampsiteRegionsQuery));
};
